<template>
  <div>
    <div id="daumPostCode">
      <vue-daum-postcode @complete="complete">
        <template #loading>
          <div>{{locale.data_loading}}</div>
        </template>
      </vue-daum-postcode>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DaumPost',
  props: [
    'locale'
  ],
  components: {
  },
  mounted () {
  },
  data () {
    return {
    }
  },
  methods: {
    complete (data) {
      const lang = this.$route.params.ln
      const address = lang === 'ko'
        ? data.roadAddress
        : data.roadAddressEnglish
      const selectData = {
        address: address,
        name: data.buildingName || address
      }
      console.log(selectData)
      this.$emit('select', selectData)
    }
  }
}
</script>

<style lang="scss" scoped>
#daumPostCode {
  height: 100%;
}
iframe {
  width: 100%;
  height: 100%;
}
</style>
